import React from "react";
import { FontAwesomeIcon, Props as FaProps } from "@fortawesome/react-fontawesome";
import { FC } from "react";

// #1971c2
export const Fa: FC<FaProps> = props => {
  return <FontAwesomeIcon {...props} color={props.color || "#1971c2"} />;
};
